export function getInterpolatedMessageBody(
  // an array of {{tokens}} to parse the message body for
  tokens: string[] | readonly string[],
  // the uninterpolated message body
  messageBody: string,
  // a mapping of token names to the strings you want to replace them with
  fields: { [token: string]: string }
) {
  let interpolatedMessageBody = messageBody;
  tokens.forEach(token => {
    if (fields[token]) {
      interpolatedMessageBody = interpolatedMessageBody.replace(
        new RegExp(`{{${token}}}`, 'g'),
        fields[token]
      );
    }
  });
  return interpolatedMessageBody;
}
